import React, { useState, createContext, useEffect, } from "react";
import { useExploreQuery, useSolutionQuery, } from "../queries";
export const SolutionContext = createContext(null);
export const SolutionProvider = ({ children }) => {
    const [selectedTab, setSelectedTab] = useState();
    const [selectedSolution, setSelectedSolution] = useState();
    const [tabs, setTabs] = useState();
    const [footerContent, setFooterContent] = useState();
    const exploreQuery = useExploreQuery();
    const solutionQuery = useSolutionQuery(selectedTab);
    useEffect(() => {
        if (!exploreQuery.isLoading && exploreQuery.data) {
            setSelectedTab(exploreQuery.data.explore_tabs[0]);
            setTabs(exploreQuery.data.explore_tabs);
            setFooterContent(exploreQuery.data.explore_footer);
        }
    }, [exploreQuery.data, exploreQuery.isLoading]);
    useEffect(() => {
        if (!solutionQuery.isLoading && solutionQuery.data) {
            setSelectedSolution(solutionQuery.data);
        }
    }, [solutionQuery.isLoading, solutionQuery.data]);
    return (React.createElement(SolutionContext.Provider, { value: {
            selectedTab,
            setSelectedTab,
            selectedSolution,
            tabs,
            footerContent
        } }, children));
};
